import { readConsentCookie, writeConsentCookie } from './consentCookie';
import { updateGoogleConsentMode } from './consentModeMapping';

interface AccountConsentPreferences {
  categories: string[];
  consent_id: string;
  consented_at: string;
  last_updated_at: string;
}

interface Account {
  cookie_consent_preferences?: AccountConsentPreferences;
}

export async function reconcileConsent(
  account: Account,
  authAxios: { patch: (url: string, data: unknown) => Promise<unknown> },
  hideBanner?: () => void
) {
  try {
    const cookie = readConsentCookie();
    const cookieCategories = cookie?.categories || [];
    const cookieTimestamp = cookie?.lastConsentTimestamp;
    const accountConsent = account.cookie_consent_preferences;

    if (accountConsent?.categories && accountConsent.last_updated_at) {
      if (
        !cookieTimestamp ||
        new Date(accountConsent.last_updated_at) > new Date(cookieTimestamp)
      ) {
        writeConsentCookie(accountConsent.categories);
        updateGoogleConsentMode(accountConsent.categories);
        hideBanner?.();
        return;
      }
    }

    if (cookieCategories.length > 0 && cookieTimestamp) {
      await authAxios.patch('/internal/v1/accounts/cookie-consent', {
        cookie_consent_preferences: {
          categories: cookieCategories,
          consent_id: cookie?.consentId,
          consented_at: cookie?.consentTimestamp,
          last_updated_at: cookieTimestamp,
        },
      });
    }
  } catch (error) {
    console.error('Failed to reconcile consent preferences:', error);
  }
}
